<template>
  <div></div>
</template>

<script>
export default {
  path: 'history',
  privCode: 'qa_records',
  displayNameKey: 'history',
  name: 'history',
  isLink: true,
};
</script>



// WEBPACK FOOTER //
// src/modules/SSM/QARecords.vue